import { createAsyncThunk } from '@reduxjs/toolkit';
import TimeSheetApi from '@infrastructure/timeSheet-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const GetTimeSheetsByMonthYearAndAssignmentIdAsync = createAsyncThunk('timeSheet/getByMonthYearAndAssigmentId', async (dateAndMonth, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TimeSheetApi.getWeeksByMonthYearAndAssignmentId(dateAndMonth);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getTimeSheetForAdminUsingStatus = createAsyncThunk('timeSheet/getTimeSheetUsingStatus', async (status, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TimeSheetApi.getTimeSheetsUsingStatus(status);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadMonthlyTimeSheetAsync = createAsyncThunk('timeSheet/uploadMonthlyTimeSheetAsync', async (document, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TimeSheetApi.uploadMonthlyTimeSheet(document);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getTimeSheetCountsByStatusAsync = createAsyncThunk('timeSheet/getTimeSheetCountsByStatusAsync', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TimeSheetApi.getTimeSheetCountsByStatus();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
